import { useState } from "react";

function formatPrice(price) {
  if (!price) return "";
  return `${String(price).replace("€", "").trim()} €`;
}

export default function ProductModal({ product, onClose }) {
  const whatsappNumber = "34692593183";

  const images = [
    product.image_url,
    product.image_url_2,
    product.image_url_3,
  ].filter(Boolean);

  const sizes = product.sizes
    ? product.sizes.split(",").map((size) => size.trim()).filter(Boolean)
    : [];

  const [selectedImage, setSelectedImage] = useState(images[0] || null);
  const [zoomImage, setZoomImage] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [quantity, setQuantity] = useState(1);

  const message = encodeURIComponent(
`Hola,

Quiero pedir este producto:

Producto: ${product.name}
Ref: ${product.sku || ""}
Precio: ${formatPrice(product.price)}
${sizes.length > 0 ? `Talla: ${selectedSize || "Por confirmar"}` : ""}
Cantidad: ${quantity}

Gracias.`
  );

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <div className="modalBackdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <button className="close" onClick={onClose}>×</button>

        {selectedImage && (
          <img
            src={selectedImage}
            alt={product.name}
            className="modalImage"
            onClick={() => setZoomImage(selectedImage)}
          />
        )}

        {images.length > 1 && (
          <div className="imageGallery">
            {images.map((image, index) => (
              <button
                key={image}
                type="button"
                className={`galleryThumb ${selectedImage === image ? "active" : ""}`}
                onClick={() => setSelectedImage(image)}
              >
                <img src={image} alt={`${product.name} ${index + 1}`} />
              </button>
            ))}
          </div>
        )}

        <p className="category">{product.category}</p>
        <h2>{product.name}</h2>
        {product.sku && (
  <p className="productSku">
    Ref: {product.sku}
  </p>
)}
        <p>{product.full_desc || product.short_desc}</p>
        <h3>{formatPrice(product.price)}</h3>

        {sizes.length > 0 && (
          <label className="modalField">
            Talla
            <select
              value={selectedSize}
              onChange={(e) => setSelectedSize(e.target.value)}
            >
              <option value="">Selecciona una talla</option>
              {sizes.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        )}

        <div className="quantityBox">
          <span>Cantidad</span>

          <div className="quantityControls">
            <button
              type="button"
              onClick={() => setQuantity((current) => Math.max(1, current - 1))}
            >
              −
            </button>

            <strong>{quantity}</strong>

            <button
              type="button"
              onClick={() => setQuantity((current) => current + 1)}
            >
              +
            </button>
          </div>
        </div>

        <a
          className="primaryButton"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Pedir por WhatsApp
        </a>

        {zoomImage && (
  <div className="zoomBackdrop" onClick={() => setZoomImage(null)}>
    <button className="zoomClose" type="button">
      ×
    </button>

    <img
      src={zoomImage}
      alt={product.name}
      className="zoomImage"
      onClick={(event) => event.stopPropagation()}
    />
  </div>
)}
      </div>
    </div>
  );
}